/*
    This file is a shim to make rule utilities available globally.  We concat it with the rules bundle
    after the bundle is already made.
*/

var Units = tools.Units;